import './App.css';
import IrisTracker from './components/IrisTracker';

function App() {
  return (
    <div>
    <IrisTracker />
  </div>
  );
}

export default App;
